import { LocalStorageUtils } from '@/helper/LocalStorageUtils'

export class UnreadNewsService {
  private static localStorageKey = 'read_news'

  public static markAsRead(ids: string[]) {
    let readIds = LocalStorageUtils.getFromJson(this.localStorageKey) as string[]

    if (!Array.isArray(readIds)) {
      readIds = []
    }

    const newUnreadIds = ids.filter(id => !readIds.includes(id))

    readIds.push(...newUnreadIds)
    LocalStorageUtils.saveAsJson(this.localStorageKey, readIds)
  }

  public static filterUnreadNews(id: string) {
    const readIds = LocalStorageUtils.getFromJson(this.localStorageKey) as string[]

    return !readIds || !readIds.includes(id)
  }
}
